import React, { useEffect } from 'react';
import { Switch, Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { get } from 'lodash';

import { Box } from 'components';
import { StepProps } from 'common/types';
import { RootState } from 'redux-modules/store/rootState';
import { FUNDING_ENTITY_TYPE } from 'common/utils/constants';

import styles from './styles';
import IndividualFundingForm from '../IndividualFundingForm';
import EntityFundingForm from '../EntityFundingForm';

const KYCDetails = ({
  handleNext,
  handleBack,
  spv,
  investor,
  kycDetail,
  isRollover = false,
}: StepProps) => {
  const classes = styles();

  const [individualEntity, setIndividualEntity] = React.useState<boolean>(true);
  const [fundingEntityType, setFundingEntityType] = React.useState<string>(
    FUNDING_ENTITY_TYPE.INDIVIDUAL,
  );

  const { investmentProcess } = useSelector(
    ({ Investor }: RootState) => Investor,
  );
  const { investorKyc } = investor;
  const profileKyc = investorKyc?.find((kyc: any) => kyc.spv === 'PROFILE');

  const handleChange = (event: any) => {
    setIndividualEntity(!event.target.checked);
  };

  useEffect(() => {
    if (get(kycDetail, 'id')) {
      if (
        get(kycDetail, 'fundingEntityType') === FUNDING_ENTITY_TYPE.INDIVIDUAL
      )
        setIndividualEntity(true);
      else setIndividualEntity(false);
    }
  }, [kycDetail]);

  useEffect(() => {
    if (individualEntity) setFundingEntityType(FUNDING_ENTITY_TYPE.INDIVIDUAL);
    else setFundingEntityType(FUNDING_ENTITY_TYPE.ENTITY);
  }, [individualEntity]);

  return (
    <Box className={classes.kycDetails}>
      <Typography variant="h3" className={classes.investNowFormHeader}>
        Funding entity details:
      </Typography>
      <Box className={classes.switchBox}>
        <Switch
          classes={{
            root: classes.switchRoot,
            switchBase: classes.switchBase,
            thumb: classes.thumb,
            track: classes.track,
            checked: classes.checked,
          }}
          checked={!individualEntity}
          onChange={handleChange}
          name="fundingEntityType"
          inputProps={{ 'aria-label': 'secondary checkbox' }}
          disabled={get(investmentProcess, 'docuSignDocumentSigned')}
        />
      </Box>
      {/* <Typography variant="body1" className={classes.fundingTypeText}>
        {fundingEntityType}
      </Typography> */}
      {fundingEntityType === FUNDING_ENTITY_TYPE.INDIVIDUAL ? (
        <IndividualFundingForm
          handleNext={handleNext}
          handleBack={handleBack}
          spv={spv}
          investor={investor}
          kycDetail={kycDetail}
          profileKyc={profileKyc}
          isRollover={isRollover}
        />
      ) : (
        <EntityFundingForm
          handleNext={handleNext}
          handleBack={handleBack}
          spv={spv}
          investor={investor}
          kycDetail={kycDetail}
          profileKyc={profileKyc}
          isRollover={isRollover}
        />
      )}
    </Box>
  );
};
export default KYCDetails;
